import config from './config.json';

export const getConfig = () => {
  return config;
};

export const getApiUrl = () => {
  return config.API_URL;
};

// Add other config getters as needed
//export const getOtherConfig = () => {
  //return config.otherConfig;
//};

export const isTTSAudioEnabled = () => {
  return import.meta.env.VITE_ENABLE_TTS_AUDIO !== 'false';
};

export const isDevWatermarkEnabled = (): boolean => {
  if (typeof (config as any)?.SHOW_DEV_WATERMARK === 'boolean') {
    return (config as any).SHOW_DEV_WATERMARK;
  }
  return import.meta.env.VITE_SHOW_DEV_WATERMARK === 'true';
};

export const hebrewLetters = [
  "א", "ב", "ג", "ד", "ה", "ו", "ז", "ח", "ט", "י",
  "יא", "יב", "יג", "יד", "טו", "טז", "יז", "יח", "יט", "כ",
  "כא", "כב", "כג", "כד", "כה", "כו", "כז", "כח", "כט", "ל",
  "לא", "לב", "לג", "לד", "לה", "לו", "לז", "לח", "לט", "מ",
  "מא", "מב", "מג", "מד", "מה", "מו", "מז", "מח", "מט", "נ",
  "נא", "נב", "נג", "נד", "נה", "נו", "נז", "נח", "נט", "ס",
  "סא", "סב", "סג", "סד", "סה", "סו", "סז", "סח", "סט", "ע",
  "עא", "עב", "עג", "עד", "עה", "עו", "עז", "עח", "עט", "פ",
  "פא", "פב", "פג", "פד", "פה", "פו", "פז", "פח", "פט", "צ",
  "צא", "צב", "צג", "צד", "צה", "צו", "צז", "צח", "צט", "ק",
  "קא", "קב", "קג", "קד", "קה", "קו", "קז", "קח", "קט", "ר",
  "רא", "רב", "רג", "רד", "רה", "רו", "רז", "רח", "רט", "ש",
  "שא", "שב", "שג", "שד", "שה", "שו", "שז", "שח", "שט", "ת",
  "תא", "תב", "תג", "תד", "תה", "תו", "תז", "תח", "טת"

];

export const audioUrlMapping: Record<string, string> = {
  "goodexercisechoise": "https://shoonitdatastore.blob.core.windows.net/audiofiles/goodexercisechoise.mp3?sp=r&st=2025-10-01T06:33:21Z&se=2028-01-01T15:48:21Z&spr=https&sv=2024-11-04&sr=b&sig=OvybjAmQ3wXt0KsATsVzKgrw%2FFU35Spp9vR92AmGjiY%3D",
  "exercisequestions_voice_exaplin": "https://shoonitdatastore.blob.core.windows.net/audiofiles/exercisequestions_voice_exaplin.mp3?sp=r&st=2025-10-01T06:48:55Z&se=2028-01-01T16:03:55Z&spr=https&sv=2024-11-04&sr=b&sig=qwQ7XXg9Y6AZfIf%2BvKHZWPZ6%2BifiKRMb8MLrB0T3zLc%3D",
  "questionsteps_voice_exaplin":"https://shoonitdatastore.blob.core.windows.net/audiofiles/questionsteps_voice_exaplin.mp3?sp=r&st=2025-10-01T06:51:57Z&se=2028-01-01T16:06:57Z&spr=https&sv=2024-11-04&sr=b&sig=uHZBit1qJRUty6OvgrZe68QVYKMPXp%2Bu4xNLrTuw20k%3D",
  "chatpage_voice_exaplin1":"https://shoonitdatastore.blob.core.windows.net/audiofiles/chatpage_voice_exaplin1.mp3?sp=r&st=2025-10-01T06:53:29Z&se=2028-01-01T16:08:29Z&spr=https&sv=2024-11-04&sr=b&sig=5JIEz2LXo%2B5fcnE61uY4BADxp2fJq1z28Trwvu46qAc%3D",
  "chatpage_voice_exaplin2":"https://shoonitdatastore.blob.core.windows.net/audiofiles/chatpage_voice_exaplin2.mp3?sp=r&st=2025-10-01T06:54:56Z&se=2028-01-01T16:09:56Z&spr=https&sv=2024-11-04&sr=b&sig=OJerv5P0YC78eTXS8nWdmR2BlELNU4UCqGJYMc8E3yo%3D",
  "chatpage_before_solution_display":"https://shoonitdatastore.blob.core.windows.net/audiofiles/chatpage_before_solution_display.mp3?sp=r&st=2025-10-01T06:56:25Z&se=2028-01-01T16:11:25Z&spr=https&sv=2024-11-04&sr=b&sig=Nc3hxnuMPf9Si%2FTQk38i2QmnhohYWcGTEpbYHjqje3o%3D",
  "chatpage_voice_exaplin3":"https://shoonitdatastore.blob.core.windows.net/audiofiles/chatpage_voice_exaplin3.mp3?sp=r&st=2025-10-01T06:57:15Z&se=2028-01-01T16:12:15Z&spr=https&sv=2024-11-04&sr=b&sig=ww7sxh0OReLIatTA%2BCfM6AHX4HSc1FLSm6F4gG4ecwU%3D",
  "chatpage_voice_exaplin4":"https://shoonitdatastore.blob.core.windows.net/audiofiles/chatpage_voice_exaplin4.mp3?sp=r&st=2025-10-01T06:58:21Z&se=2028-01-01T16:13:21Z&spr=https&sv=2024-11-04&sr=b&sig=nMZcAKUBUzXvufuTr2nCjzKsQ1D8dpDUw9%2FBrfXm2Qk%3D",
  "chatpage_voice_exaplin5":"https://shoonitdatastore.blob.core.windows.net/audiofiles/chatpage_voice_exaplin5.mp3?sp=r&st=2025-10-01T06:49:42Z&se=2028-01-01T16:04:42Z&spr=https&sv=2024-11-04&sr=b&sig=X5IYJLEzF2cu7eRclBMzabJ4X3AMktgi6dFDTIVXOTE%3D",  
  "chatpage_voice_exaplin6":"https://shoonitdatastore.blob.core.windows.net/audiofiles/chatpage_voice_exaplin6.mp3?sp=r&st=2025-10-01T06:48:35Z&se=2028-01-01T16:03:35Z&spr=https&sv=2024-11-04&sr=b&sig=MPfFobC6%2BaTurHy3gQGNViarj7lyVt%2FZz%2BCEqycRKhE%3D"    
};

export const getAudioUrl = (textKey: string): string | null => {
  return audioUrlMapping[textKey] || null;
};
